export default function initRDStation () {
  try {
    let rdScript = document.createElement('script')
    rdScript.setAttribute('src', 'https://d335luupugsy2.cloudfront.net/js/loader-scripts/5a5ba5b3-6024-4743-9d78-573b33f381fe-loader.js')
    document.body.appendChild(rdScript)
    console.log('RDScript iniciado com sucesso')
  } catch (err) {
    console.log('Falha ao iniciar RDScript')
  }
}
